/* eslint semi:0 */
import { makeSafeFn } from 'utils/fn'
import AnalyticsBaseService from 'services/analytics/analyticsBaseService'
import utilsScript from 'utils/script'
import userAgent from 'utils/ua'
import pageDataObject from 'application/pageDataObject'

const QUANTCAST_ACCOUNT_ID = 'p-2wFeGW5ExM-u7'

let quantcast = utilsScript.external.load({ name: 'quantcast', loadNow: true })

class QuantcastService extends AnalyticsBaseService {

  get className() { return "QuantcastService" }

  pageViewed() {
    this.trackEvent({
      qacct: QUANTCAST_ACCOUNT_ID,
      event: 'pageview',
      labels: encodeURI(this.pageViewData)
    })
  }

  get pageViewData() {
    if (pageDataObject.get('post')) {
      let platform = userAgent.isNativeApp ? 'WebView-Native' : userAgent.isDesktop ? 'desktop' : 'mobile_web'
      return `${ platform }.${ pageDataObject.get('page.locale') }.post`
    }
    else {
      return `tags #{ pageDataObject.get('page.name') }`
    }
  }

  trackEvent(data) {
    this.logAnalytics(data)
    quantcast( makeSafeFn( () => { window._qevents.push(data) }) )
  }

}

export default QuantcastService


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/quantcastService.js